import Axios from 'axios';
var PaymentVoucherService = (function () {
    function PaymentVoucherService() {
    }
    PaymentVoucherService.prototype.getList = function (params) {
        return Axios.get('supplierclientapi/purchase_order_payment_voucher/list', { params: params });
    };
    PaymentVoucherService.prototype.handleBill = function (params) {
        return Axios.post('supplierclientapi/purchase_order_payment_voucher/process', params);
    };
    PaymentVoucherService.prototype.getOnlinePayList = function (params) {
        return Axios.post('supplierclientapi/purchaseorder/online_payment_list', params);
    };
    PaymentVoucherService.prototype.getOnlinePayListV2 = function (params) {
        return Axios.get('supplierclientapi/purchaseorder/online_payment_list_v2', { params: params });
    };
    PaymentVoucherService.prototype.confirmPayStatus = function (params) {
        return Axios.post('supplierclientapi/purchaseorder/confirm_online_payment_status', params);
    };
    PaymentVoucherService.createInstance = function () {
        PaymentVoucherService.getInstance();
    };
    PaymentVoucherService.getInstance = function () {
        return this._instance || (this._instance = new this());
    };
    return PaymentVoucherService;
}());
export default PaymentVoucherService;
